import { createContext, useContext, ReactNode } from 'react';
import { useSubscription, SubscriptionState } from '@/hooks/useSubscription';

interface SubscriptionContextType extends SubscriptionState {
  refreshSubscription: () => Promise<void>;
}

const SubscriptionContext = createContext<SubscriptionContextType | null>(null);

export function SubscriptionProvider({ children }: { children: ReactNode }) {
  const subscription = useSubscription();

  return (
    <SubscriptionContext.Provider value={subscription}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscriptionContext() {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscriptionContext must be used within a SubscriptionProvider');
  }
  return context;
}

// Optional hook that returns null if no provider (for non-authenticated pages)
export function useOptionalSubscription() {
  return useContext(SubscriptionContext);
}
